import api from './api';
import { SUBJECTS } from '../config/Config';

const endpoint = SUBJECTS;

export const subjectService = {
  list: async () => {
    return api.get(endpoint);
  },
  create: async (data) => {
    return api.post(endpoint, data);
  },
  update: async (id, data) => {
    return api.patch(`${endpoint}${id}/`, data);
  },
  remove: async (id) => {
    return api.delete(`${endpoint}${id}/`);
  }
};
